import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { setLandAssemblyLayer } from '../../../../redux/land_assembly/Actions';

import { MenuItem, makeStyles, Grid } from '@material-ui/core';

import SimpleHeading from '../common/SimpleHeading';
import SelectTextField from '../../../Common/UI/SelectTextField';
import InputLabel from '../../../Common/UI/InputLabel';

const useStyles = makeStyles(theme => style(theme));

function LandAssemblySearchSettings() {
    const classes = useStyles();
    const layerId = useSelector(state => state.landAssembly.layerId);
    const searchChoices = useSelector(state => {
        return state.user.features['landAssembly'].layers?.map(landAssemblyLayer =>
            state.layers.layers.find(layer => layer.id === landAssemblyLayer.layerId)
        );
    });
    const dispatch = useDispatch();
    const dispatchSetLandAssemblyLayer = id => dispatch(setLandAssemblyLayer(id));

    function handleLayerChange(event) {
        dispatchSetLandAssemblyLayer(event.target.value);
    }

    return (
        <div className={classes.root}>
            <SimpleHeading
                label="1. SELECT THE LAND ASSEMBLY DATASET"
                tooltip="Select dataset to create a land assembly for"
            />
            <Grid container spacing={2} alignContent="center" alignItems="center">
                <Grid item xs={4}>
                    <InputLabel label="Land Assemble By" />
                </Grid>
                <Grid item xs={8}>
                    <SelectTextField
                        value={layerId || ''}
                        placeholder="select an option"
                        onChange={handleLayerChange}
                        fullWidth>
                        {searchChoices?.map((e, idx) => (
                            <MenuItem key={e.id} value={e.id}>
                                {e.name}
                            </MenuItem>
                        ))}
                    </SelectTextField>
                </Grid>
            </Grid>
        </div>
    );
}

const style = theme => ({
    root: {
        '&> *:first-child': {
            marginBottom: theme.constants.verticalMargin
        }
    }
});

export default LandAssemblySearchSettings;
